var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPromo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8101 18.7768C11.5351 19.0518 11.2028 19.1893 10.8132 19.1893C10.4236 19.1893 10.0913 19.0518 9.81634 18.7768L1.22259 10.183C1.06981 10.0302 0.966688 9.86981 0.913216 9.70176C0.859744 9.5337 0.833008 9.35801 0.833008 9.17467V2.20801C0.833008 1.81079 0.962869 1.48231 1.22259 1.22259C1.48231 0.962869 1.81079 0.833008 2.20801 0.833008H9.17467C9.35801 0.833008 9.54134 0.859744 9.72467 0.913216C9.90801 0.966688 10.0761 1.06981 10.2288 1.22259L18.7768 9.77051C19.067 10.0608 19.2122 10.4007 19.2122 10.7903C19.2122 11.1799 19.067 11.5198 18.7768 11.8101L11.8101 18.7768ZM10.8705 17.8372L17.8372 10.8705L9.17467 2.20801H2.20801V9.17467L10.8705 17.8372ZM4.61426 5.78301C4.93509 5.78301 5.21391 5.66461 5.45072 5.4278C5.68752 5.19099 5.80592 4.91217 5.80592 4.59134C5.80592 4.27051 5.68752 3.99169 5.45072 3.75488C5.21391 3.51808 4.93509 3.39967 4.61426 3.39967C4.29342 3.39967 4.01461 3.51808 3.7778 3.75488C3.54099 3.99169 3.42259 4.27051 3.42259 4.59134C3.42259 4.91217 3.54099 5.19099 3.7778 5.4278C4.01461 5.66461 4.29342 5.78301 4.61426 5.78301Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromo);
export default __webpack_public_path__ + "static/media/promo.0c0c688bc2b5927df2e40ac07a35c230.svg";
export { ForwardRef as ReactComponent };